import React, {createContext, ReactNode, useContext, useEffect, useState} from 'react';
import {useZooPassAppContext} from "../Context/ZooPassAppContext";
import {IZooPassAnswersContext, useZooPassAppAnswersContext, ZooPassAppAnswersContext} from "../Context/ZooPassAnswersContext";
import ZooPassLocalStateUtility from "../Utilities/ZooPassLocalStateUtility";
import {StepTitleContent} from "./PanelContents/StepTitleContent";
import {ImageAnswerComponent} from "./PanelContents/ImageAnswer";
import classNames from 'classnames';

interface SidebarStepItemProps {
    sidebarStep: number;
    label: string;
    children: ReactNode;
}

export const SidebarStepItem : React.FC<SidebarStepItemProps> = (props) => {

    const [isDisabled, setDisabled] = useState(true);
    /**
     * 0 = future step / disabled
     * 1 = current step
     * 2 = past step / selected
     */
    const [stepState, setStepState] = useState<0 | 1 | 2>(0);
    
    let {
        loading
    } = useZooPassAppContext();

    let {
        answersData,
        answersLoading,
        updateContext
    } = useZooPassAppAnswersContext();

    useEffect(() => {
        setDisabled(answersData === null || answersData.step <= props.sidebarStep);
        if(answersData != null){
            if(answersData.step > props.sidebarStep){
                setStepState(2);
            }
            if(answersData.step == props.sidebarStep){
                setStepState(1);
            }
            if(answersData.step < props.sidebarStep){
                setStepState(0);
            }
        }else{
            setStepState(0);
        }
    }, [answersData, answersData?.step]);
    
    const handleValueClick = () => {
        if(answersData != null){
            answersData.previousStep = answersData.step;
            answersData.step = props.sidebarStep;
            updateContext({type: "setAnswers", value: answersData});
        }
    };
    
    return !answersLoading && !loading &&
        answersData !== null && (
            <>
                <button
                    className={classNames('progress-step', 'col', {'progress-step--completed': stepState == 2}, {'progress-step--current': stepState == 1}, {'progress-step--disabled': isDisabled})}
                    disabled={isDisabled} onClick={handleValueClick}>
                    
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" className={classNames("progress-step__check", {'d-none' : stepState == 1})}>
                        <path d="M12 2c5.52 0 10 4.48 10 10s-4.48 10-10 10S2 17.52 2 12 6.48 2 12 2m-1 14.5l7-7-1.41-1.41L11 13.67l-3.09-3.08L6.5 12l4.5 4.5z"></path>
                    </svg>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" className={classNames("progress-step__check", {'d-none' : stepState != 1})}>
                        <path d="M12 2c5.52 0 10 4.48 10 10s-4.48 10-10 10S2 17.52 2 12 6.48 2 12 2m0 2c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8m-1 12.5L6.5 12l1.41-1.41L11 13.67l5.59-5.58L18 9.5l-7 7z"></path>
                    </svg>
                    <div className="progress-step__details">
                        <h6>{props.label}</h6>
                        {props.children}
                    </div>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                         className="progress-step__chevron">
                        <path d="M8.59 16.58L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.42z"></path>
                    </svg>
                </button>
            </>
        );
};

